import { render, staticRenderFns } from "./ProductTypeSelect.vue?vue&type=template&id=1e3a12b5&"
import script from "./ProductTypeSelect.vue?vue&type=script&lang=js&"
export * from "./ProductTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports